import React from 'react';
import Chart from 'react-apexcharts';
import { convertSubTagString } from 'utils/utils';
import { statusTypeStandardization } from 'utils/utils';
import { lineGraphReferenceValue } from 'utils/code';
import './LineGraph.css';

const LineGraph = (props) => {
  const criterionColorMap = {
    warning: '#edb900',
    danger: '#FF0000',
  };

  const criterion = props.criterion.map((data) => {
    if (data.standType === 'criterion') {
      return {};
    }

    return {
      y: data.standVal,
      borderColor: criterionColorMap[data.standType],
      label: {
        borderColor: criterionColorMap[data.standType],
        style: {
          color: '#fff',
          fontSize: '9px',
          background: criterionColorMap[data.standType] + '35',
        },
        text: data.standName,
      },
    };
  });

  const config = {
    options: {
      chart: {
        group: 'social',
        type: 'line',
        toolbar: {
          show: true,
          tools: {
            download: false,
            selection: false,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: false,
          },
        },
        animations: {
          enabled: false,
        },
      },
      colors: ['#50bb5b'],
      annotations: {
        yaxis: criterion,
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'straight',
        width: 2,
      },
      markers: {
        size: 3,
        strokeWidth: 0,
        hover: {
          size: 5,
        },
      },
      tooltip: {
        theme: 'dark',
        y: {
          title: {
            formatter: () => {
              //return convertSubTagString(props.graphId.toUpperCase());
              return convertSubTagString(props.graphId === 'hc' && props.flag === "0" ? 'CH4' : props.graphId.toUpperCase());
            },
          },
        },
      },
      grid: {
        position: 'front',
        borderColor: '#90A4AE30',
      },
      yaxis: {
        tickAmount: lineGraphReferenceValue[props.graphId].tickAmount,
        max: lineGraphReferenceValue[props.graphId].max,
        min: lineGraphReferenceValue[props.graphId].min,
        labels: {
          minWidth: 10,
          style: {
            colors: ['#fff', '#fff', '#fff', '#fff', '#fff', '#fff', '#fff', '#fff'],
          },
        },
      },
      xaxis: {
        categories: props.categories,
        labels: {
          show: false,
          hideOverlappingLabels: true,
          style: {
            colors: ['#fff', '#fff', '#fff', '#fff', '#fff', '#fff', '#fff', '#fff', '#fff', '#fff'],
            fontSize: '10px',
          },
        },
      },
    },
    series: [
      {
        data: props.data,
      },
    ],
  };

  return (
    <div className="graphMainPopup-lineGraph">
      <div className="title">{statusTypeStandardization(props.graphId, props.flag)}</div>
      <Chart type="line" width="550" height="150" options={config.options} series={config.series} />
    </div>
  );
};

export default LineGraph;
